import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ContractMessage } from '../../../../../types/ContractMessage';
import { VesselMessage } from '../../../../../types/VesselMessage';
import { updateVessel } from '../../../../common/api/clients/vessel.api';
import { queries } from '../../../../common/api/queryKeys/queries';
import { toVesselUpdateRequest } from '../../utils/toVesselUpdateRequest';

interface UpdateVesselDefaultContractParams {
    vessel: VesselMessage;
    contract: ContractMessage | null;
}

export const useVesselDefaultContractUpdate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ vessel, contract }: UpdateVesselDefaultContractParams) =>
            updateVessel({
                vesselId: vessel.id,
                vessel: {
                    ...toVesselUpdateRequest(vessel),
                    defaultSupplierId: contract?.supplierId ?? vessel.defaultSupplierId ?? null,
                    defaultContractId: contract?.id ?? null,
                },
            }),
        onSuccess: async (_, { vessel }) => {
            await queryClient.invalidateQueries({ queryKey: queries.vessels.detail(vessel.id).queryKey });
            await queryClient.invalidateQueries({ queryKey: queries.contracts._def });
        },
    });
};
